<template>
    <div class="flex-row br ai-center amount-masked-input" :class="{'lightgrey-bkg': disabled, 'b-1': !disabled}">
        <el-input
            type="text"
            class="b-0"
            :placeholder="placeholder"
            :disabled="disabled"
            v-model="currentValue"
            @blur="isFocus = false"
            @focus="isFocus = true">
        </el-input>
        <span :data-symbol="symbol" class="currency-symbol pr-2 nowrap"></span>
    </div>
</template>

<script>
    import { createNamespacedHelpers } from 'vuex';
    const corpMapState = createNamespacedHelpers('corp').mapState;

    export default {
        props: {
            value: {
                type: [Number, String],
                required: false,
            },
            placeholder: {
                type: String,
                required: false,
                default: ''
            },
            symbol: {
                type: String,
                required: false,
                default: window.App.numformat.currencysymbol
            },
            disabled: {
                type: Boolean,
                required: false
            },
            numFormat: {
                type: Object,
                required: false
            }
        },
        data(){
            return {
                isFocus: false,
                numberFormat: {}
            }
        },
        created() {
            this.numberFormat = this.numFormat ? this.numFormat : this.numberFormatState;
        },
        computed: {
            ...corpMapState({
                numberFormatState: 'numformat'
            }),
            position() {
                switch (this.numberFormat.currencypos) {
                    case 'left':
                        return 'prefix';
                    case 'right':
                    default:
                        return 'suffix';
                }
            },
            /**
             * On blur, set numformat of corp.
             * In case of decimals is set with "," we convert value by NBF for decimals calculation compatibility in parent form
             */
            currentValue: {
                get: function() {
                    if(_.isNil(this.value)) {
                        return null;
                    }
                    if(this.isFocus) {
                        return this.value.toString();
                    } else {
                        return this.value.toString().includes(',') ? NumberFormat.convert(this.value, { ...this.numberFormat, decimals: ','}, this.numberFormat, this.numberFormat.precision) : NumberFormat.formatToDisplay(this.value, this.numberFormat);
                    }
                },
                set: function(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '~@sellsy/styleguide/src/_variables';
    .currency-symbol {
        &::before {
            content: attr(data-symbol);
            color: $gray-100;
        }
    }
</style>
<style lang="scss">
    .amount-masked-input {
        .el-input__inner {
            border: none;
        }
    }
</style>